<form [formGroup]="form" #formDirective="ngForm" class="interlayersForm">
  @if (disabled) {
    @if (!isPallet) {
      <p class="gateMessage" data-ctx="interlayers-gate-not-pallet">{{ 'interlayers_only_pallet' | translate }}</p>
    } @else {
      <p class="gateMessage" data-ctx="interlayers-gate">{{ 'interlayers_add_layer_first' | translate }}</p>
    }
  }

  <div class="compactFields" [class.compactFieldsDisabled]="disabled">
    @if (!listEditMode) {
      <div class="input-row input-row-select">
        <gl-select id="interlayer-select" formControlName="selectedId" data-ctx="select-interlayer-template">
          <gl-option [value]="selectNewValue" [label]="'interlayers_create_new' | translate"></gl-option>
          @for (load of savedInterlayerLoads; track load.id) {
            <gl-option
              [value]="load.id"
              [label]="load.translatedName || load.name"
              class="loadOption"
            ></gl-option>
          }
        </gl-select>
      </div>
    }

    <div class="input-row input-row-name">
      <gl-input-container>
        <input
          id="interlayer-name-input"
          data-ctx="input-interlayer-name"
          type="text"
          normal-input
          formControlName="name"
          placeholder="name"
        />
      </gl-input-container>
    </div>

    <div class="input-row">
      <gl-input-container [units]="'length'">
        <input
          id="interlayer-thickness-input"
          data-ctx="input-interlayer-thickness"
          type="text"
          [numericType]="'float'"
          normal-input
          formControlName="thickness"
          placeholder="interlayers_thickness"
        />
      </gl-input-container>
      <gl-input-container>
        <input
          data-ctx="input-interlayer-frequency"
          type="text"
          [numericType]="'integer'"
          normal-input
          formControlName="frequency"
          placeholder="interlayers_frequency_label"
        />
      </gl-input-container>
    </div>

    <div class="checklist">
      <gl-checkbox formControlName="placeLastOnTop" data-ctx="checkbox-interlayer-top">{{
        'interlayers_place_last_on_top' | translate
      }}</gl-checkbox>

      <gl-checkbox formControlName="placeLastOnFirst" data-ctx="checkbox-interlayer-first">{{
        'interlayers_place_last_on_first' | translate
      }}</gl-checkbox>

      @if (!listEditMode) {
        <gl-checkbox formControlName="remember" data-ctx="checkbox-remember-interlayer">{{
          'interlayers_save_to_database' | translate
        }}</gl-checkbox>
      }
    </div>
  </div>
</form>
